"use strict";

if (!window.__customerNewsletterSubmitInit) {
  window.__customerNewsletterSubmitInit = true;

  (function () {
    const EMAIL_KEY = "cartEmailGateEmail";
    const CART_PENDING_KEY = "cartEmailGatePendingAdd";
    const RATE_LIMIT_UNTIL_KEY = "shopifyCustomerFormRateLimitUntil";
    const RATE_LIMIT_COOLDOWN_MS = 15 * 60 * 1000;

    function resolveMessage(value, fallback) {
      const message = String(value || "").trim();

      if (!message || message.includes("Translation missing:")) {
        return fallback;
      }

      return message;
    }

    function getStoredEmail() {
      try {
        return (window.cartEmailGateEmail || sessionStorage.getItem(EMAIL_KEY) || "").trim();
      } catch {
        return (window.cartEmailGateEmail || "").trim();
      }
    }

    function isClientRateLimited() {
      try {
        const until = Number(sessionStorage.getItem(RATE_LIMIT_UNTIL_KEY) || 0);

        return until > Date.now();
      } catch {
        return false;
      }
    }

    function markClientRateLimited() {
      try {
        sessionStorage.setItem(RATE_LIMIT_UNTIL_KEY, String(Date.now() + RATE_LIMIT_COOLDOWN_MS));
      } catch {
        // Ignore storage errors.
      }
    }

    function hasSuccessfulSessionEmail(email) {
      const normalized = email?.trim();

      if (!normalized) {
        return false;
      }

      return getStoredEmail().toLowerCase() === normalized.toLowerCase();
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function saveEmail(email) {
      const normalized = email?.trim();

      if (!normalized) {
        return;
      }

      window.cartEmailGateEmail = normalized;

      try {
        sessionStorage.setItem(EMAIL_KEY, normalized);
      } catch {
        // Ignore storage errors.
      }
    }

    function clearStoredEmail() {
      delete window.cartEmailGateEmail;

      try {
        sessionStorage.removeItem(EMAIL_KEY);
      } catch {
        // Ignore storage errors.
      }
    }

    function markCartPendingAdd(form) {
      try {
        if (form.classList.contains("cart-email-gate-form")) {
          sessionStorage.setItem(CART_PENDING_KEY, "true");
        }
      } catch {
        // Ignore storage errors.
      }
    }

    function clearCartPendingAdd(form) {
      try {
        if (form.classList.contains("cart-email-gate-form")) {
          sessionStorage.removeItem(CART_PENDING_KEY);
        }
      } catch {
        // Ignore storage errors.
      }
    }

    function getConsentRequiredMessage(form) {
      const fallback = "Please agree to receive emails before continuing.";

      if (form.classList.contains("cart-email-gate-form")) {
        return resolveMessage(window.cartEmailGateStrings?.consentRequired, fallback);
      }

      return resolveMessage(window.popupOverlayStrings?.consentRequired, fallback);
    }

    function getConsentCheckbox(form) {
      return (
        form.querySelector("[data-cart-email-consent]") ||
        form.querySelector("[data-popup-overlay-consent]") ||
        form.querySelector('[type="checkbox"][aria-required="true"]')
      );
    }

    function getValidationError(form, email) {
      if (!email || !isValidEmail(email)) {
        if (form.classList.contains("cart-email-gate-form")) {
          return resolveMessage(
            window.cartEmailGateStrings?.errorInvalid,
            "Please enter a valid email address.",
          );
        }

        return "Please enter a valid email address.";
      }

      const consent = getConsentCheckbox(form);

      if (consent && !consent.checked) {
        return getConsentRequiredMessage(form);
      }

      return null;
    }

    function getGenericError(form) {
      const fallback = "Something went wrong. Please try again.";

      if (form.classList.contains("cart-email-gate-form")) {
        return resolveMessage(window.cartEmailGateStrings?.errorGeneric, fallback);
      }

      return resolveMessage(window.popupOverlayStrings?.errorGeneric, fallback);
    }

    function getRateLimitError(form) {
      const fallback = "Too many attempts. Please wait a few minutes and try again.";

      if (form.classList.contains("cart-email-gate-form")) {
        return resolveMessage(window.cartEmailGateStrings?.errorRateLimit, fallback);
      }

      return resolveMessage(window.popupOverlayStrings?.errorRateLimit, fallback);
    }

    function getCaptchaError(form) {
      const fallback = "Verification failed. Please refresh the page and try again.";

      if (form.classList.contains("cart-email-gate-form")) {
        return resolveMessage(window.cartEmailGateStrings?.errorCaptcha, fallback);
      }

      return fallback;
    }

    function parseFormErrors(html) {
      if (!html || /\/challenge\?/i.test(html)) {
        return "";
      }

      const doc = new DOMParser().parseFromString(html, "text/html");
      const errorNode = doc.querySelector(
        'form[action*="/contact"] .form-status-error, form[action*="/contact"] .newsletter-form-error, form[action*="/contact"] .field-error',
      );

      return errorNode?.textContent?.trim() || "";
    }

    function isChallengeResponse(response, html) {
      const location = response.headers?.get?.("Location") || "";
      const url = response.url || "";

      if (location.includes("/challenge") || url.includes("/challenge")) {
        return true;
      }

      return /\/challenge\?[^"'\\s<>]+/i.test(html || "");
    }

    function ensureMarketingConsentField(form) {
      const consent = getConsentCheckbox(form);

      let field = form.querySelector('[name="contact[accepts_marketing]"]');

      if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = "contact[accepts_marketing]";
        form.appendChild(field);
      }

      field.value = consent?.checked ? "true" : "false";
    }

    function getSignupSourceTags(form) {
      if (form.classList.contains("cart-email-gate-form")) {
        return ["加购弹窗"];
      }

      if (form.classList.contains("popup-overlay-newsletter-form")) {
        return ["订阅弹窗"];
      }

      return [];
    }

    function ensureAttributionTags(form) {
      if (typeof window.appendMarketingAttributionTags === "function") {
        window.appendMarketingAttributionTags(form, getSignupSourceTags(form));
        return;
      }

      const tagsField = form.querySelector('[name="contact[tags]"]');

      if (!tagsField) {
        return;
      }

      const existing = tagsField.value
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
      const merged = [];

      for (const tag of [...existing, ...getSignupSourceTags(form)]) {
        if (tag && !merged.includes(tag)) {
          merged.push(tag);
        }
      }

      tagsField.value = merged.join(",");
    }

    function evaluateSubmissionResponse(form, response, html) {
      if (response.status === 429) {
        markClientRateLimited();
        return { ok: false, rateLimited: true, error: getRateLimitError(form) };
      }

      if (isChallengeResponse(response, html)) {
        return { ok: false, challenged: true, error: getCaptchaError(form) };
      }

      if (response.status === 400) {
        return { ok: false, challenged: true, error: getCaptchaError(form) };
      }

      const formError = parseFormErrors(html);

      if (formError) {
        return { ok: false, error: formError };
      }

      if (!response.ok) {
        return { ok: false, error: getGenericError(form) };
      }

      return { ok: true };
    }

    async function postViaFetch(form) {
      const action = form.getAttribute("action") || "/contact";
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 20000);

      try {
        const response = await fetch(action, {
          method: "POST",
          body: new FormData(form),
          credentials: "same-origin",
          signal: controller.signal,
          headers: {
            Accept: "text/html,application/xhtml+xml",
          },
        });

        const html = await response.text();

        return evaluateSubmissionResponse(form, response, html);
      } catch (error) {
        if (error?.name === "AbortError") {
          return { ok: false, error: getGenericError(form) };
        }

        throw error;
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    function runWithCaptcha(form, callback) {
      return new Promise((resolve) => {
        const run = async () => {
          try {
            resolve(await callback());
          } catch (error) {
            console.warn("Customer form submit failed:", error);
            resolve({ ok: false, error: getGenericError(form) });
          }
        };

        if (window.Shopify?.captcha?.protect) {
          window.Shopify.captcha.protect(form, run);
        } else {
          run();
        }
      });
    }

    window.submitShopifyCustomerForm = function submitShopifyCustomerForm(form) {
      if (!form) {
        return Promise.resolve({
          ok: false,
          error: "Something went wrong. Please try again.",
        });
      }

      ensureMarketingConsentField(form);
      ensureAttributionTags(form);

      return runWithCaptcha(form, () => postViaFetch(form));
    };

    window.isShopifyCustomerFormSuccess = function isShopifyCustomerFormSuccess(result) {
      return Boolean(result?.ok);
    };

    function ensureSubmitButtonSpinner(form) {
      const button = form.querySelector('[type="submit"]');

      if (!button || button.querySelector(".button-overlay-spinner")) {
        return;
      }

      if (!button.querySelector("span")) {
        const label = button.textContent.trim();

        if (label) {
          button.textContent = "";
          const span = document.createElement("span");
          span.textContent = label;
          button.appendChild(span);
        }
      }

      const spinner = document.createElement("div");
      spinner.className = "button-overlay-spinner hidden";
      spinner.innerHTML = '<span class="spinner-xs"></span>';
      button.appendChild(spinner);
    }

    function setFormButtonLoading(form, loading) {
      const button = form.querySelector('[type="submit"]');

      if (!button) {
        return;
      }

      button.toggleAttribute("aria-disabled", loading);
      button.classList.toggle("loading", loading);
      button.querySelector(".button-overlay-spinner")?.classList.toggle("hidden", !loading);
    }

    function notifyFormLoading(form, loading) {
      setFormButtonLoading(form, loading);
      document.dispatchEvent(
        new CustomEvent("shopify-customer-form:loading", {
          detail: { form, loading },
        }),
      );
    }

    function waitForPaint() {
      return new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
      });
    }

    function primeCaptchaForForm(form) {
      if (form.dataset.captchaPrimed === "true") {
        return;
      }

      form.dataset.captchaPrimed = "true";

      if (window.Shopify?.captcha?.protect) {
        window.Shopify.captcha.protect(form, () => {});
        return;
      }

      const emailInput = form.querySelector('[name="contact[email]"]');

      if (!emailInput) {
        return;
      }

      emailInput.dispatchEvent(new Event("focus", { bubbles: true }));
      emailInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    function bindCaptchaPrimeOnOpen(hostSelector, formSelector) {
      document.querySelectorAll(hostSelector).forEach((host) => {
        const primeForms = () => {
          host.querySelectorAll(formSelector).forEach((form) => primeCaptchaForForm(form));
        };

        if (host.hasAttribute("open")) {
          primeForms();
        }

        new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (mutation.attributeName === "open" && host.hasAttribute("open")) {
              primeForms();
            }
          }
        }).observe(host, { attributes: true, attributeFilter: ["open"] });
      });
    }

    document.querySelectorAll(".popup-overlay-newsletter-form, .cart-email-gate-form").forEach((form) => {
      form.setAttribute("novalidate", "novalidate");
      ensureSubmitButtonSpinner(form);
    });

    bindCaptchaPrimeOnOpen("popup-overlay", ".popup-overlay-newsletter-form");
    bindCaptchaPrimeOnOpen("cart-email-gate", ".cart-email-gate-form");

    document.addEventListener("popup-overlay:open", () => {
      document.querySelectorAll(".popup-overlay-newsletter-form").forEach((form) => primeCaptchaForForm(form));
    });

    document.addEventListener(
      "focusin",
      (event) => {
        const field = event.target;

        if (!(field instanceof HTMLInputElement) || field.name !== "contact[email]") {
          return;
        }

        const form = field.closest(".popup-overlay-newsletter-form, .cart-email-gate-form");

        if (form) {
          primeCaptchaForForm(form);
        }
      },
      true,
    );

    document.addEventListener(
      "submit",
      async (event) => {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
          return;
        }

        if (!form.matches(".popup-overlay-newsletter-form, .cart-email-gate-form")) {
          return;
        }

        if (form.dataset.customerFormSubmitting === "true") {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        form.dataset.customerFormSubmitting = "true";
        notifyFormLoading(form, true);

        const email = form.querySelector('[name="contact[email]"]')?.value?.trim() || "";
        const validationError = getValidationError(form, email);

        if (validationError) {
          form.dataset.customerFormSubmitting = "false";
          notifyFormLoading(form, false);
          clearCartPendingAdd(form);
          clearStoredEmail();
          document.dispatchEvent(
            new CustomEvent("shopify-customer-form:result", {
              detail: {
                form,
                email,
                result: { ok: false, error: validationError },
              },
            }),
          );
          return;
        }

        primeCaptchaForForm(form);
        await waitForPaint();

        let result;

        if (isClientRateLimited()) {
          result = { ok: false, rateLimited: true, error: getRateLimitError(form) };
        } else if (hasSuccessfulSessionEmail(email)) {
          result = { ok: true, sessionReuse: true };
        } else {
          result = await window.submitShopifyCustomerForm(form);
        }

        notifyFormLoading(form, false);

        form.dataset.customerFormSubmitting = "false";

        if (window.isShopifyCustomerFormSuccess(result)) {
          saveEmail(email);
          markCartPendingAdd(form);
        } else {
          clearStoredEmail();
          clearCartPendingAdd(form);
        }

        document.dispatchEvent(
          new CustomEvent("shopify-customer-form:result", {
            detail: { form, email, result },
          }),
        );
      },
      true,
    );
  })();
}
